// extracted by mini-css-extract-plugin
module.exports = {"container":"Confirm_container__2N2N4","confirmText":"Confirm_confirmText__3N9aX"};